<template>
    <div class="row no-gutters">
        <div class="col-md-3" v-for="card in data">
            <div :class="'card card-stats ' + card.cardClass">
                <div class="card-body">
                    <div class="card-title">
                        {{ card.title }}
                    </div>

                    <div class="card-subtitle">
                        <div class="row">
                            <div class="col-12">
                                <span class="card-stats-title">{{ formatPrice(card.amount) }}</span>
                                <span class="card-stats-subtitle"> KZT</span>
                            </div>
                            <div class="col-12">
                                <span class="card-status-count">Количество: {{ card.cnt }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AnalyticsStatistics",
        computed: {
            filterType() {
                return this.$store.state.filterType;
            },
            paymentType() {
                return this.$store.state.filterPaymentType;
            },
            dateFrom () {
                return this.$store.state.filterDateFrom
            },
            dateTo () {
                return this.$store.state.filterDateTo
            },
            merchantId() {
                return this.$store.state.merchantId;
            },
            admin() {
                return this.$store.state.admin;
            },
            acquiringId() {
                return this.$store.state.acquiringId;
            },
            mpsId() {
                return this.$store.state.mpsId;
            },
            acquirerId() {
                return this.$store.state.acquirerId;
            }
        },
        watch: {
            filterType() {
                if (this.dateFrom != null)
                    this.apiCall(this.dateFrom, this.dateTo)
            },
            paymentType() {
                this.apiCall(this.dateFrom, this.dateTo);
            },
            merchantId() {
                this.apiCall(this.dateFrom, this.dateTo);
            },
            acquiringId() {
                this.apiCall(this.dateFrom, this.dateTo);
            },
            acquirerId() {
                this.apiCall(this.dateFrom, this.dateTo);
            },
            mpsId() {
                this.apiCall(this.dateFrom, this.dateTo);
            }
        },
        data() {
            return {
                data: {
                    success: {
                        amount: 0,
                        cnt: 0,
                        extended_status: [1, 5],
                        title: 'Успешно',
                        cardClass: 'card-stats--success'
                    },
                    failed: {
                        amount: 0,
                        cnt: 0,
                        extended_status: [6],
                        title: 'Ошибка',
                        cardClass: 'card-stats--error'
                    },
                    timeout: {
                        amount: 0,
                        cnt: 0,
                        extended_status: [7],
                        title: 'Незавершенные',
                        cardClass: 'card-stats--timeout'
                    },
                    inProcess: {
                        amount: 0,
                        cnt: 0,
                        extended_status: [2],
                        title: 'В ожидании',
                        cardClass: 'card-stats--waiting'
                    },
                    refunded: {
                        amount: 0,
                        cnt: 0,
                        extended_status: [5],
                        title: 'Возврат',
                        cardClass: 'card-stats--refund'
                    },
                    canceled: {
                        amount: 0,
                        cnt: 0,
                        extended_status: [4],
                        title: 'Отмена',
                        cardClass: 'card-stats--сanceled'
                    }
                }
            }
        },
        mounted() {
            this.apiCall(this.dateFrom, this.dateTo);
        },
        methods: {
            apiCall(dateFrom, dateTo) {
                this.$store.commit('setLoading');
                let params = {
                    'payment-type': this.paymentType,
                    'date-from': dateFrom,
                    'date-to': dateTo,
                    'acquiring-id': this.acquiringId,
                    'mps-id': this.mpsId,
                    'acquirer-id': this.acquirerId
                };
                if (this.merchantId) {
                    params['merchant-id'] = this.merchantId;
                }
                axios.get('/admin/analytics/total-status-group', {
                    params: params,
                }).then(response => {
                        for (let d in this.data) {
                            this.data[d].amount = 0;
                            this.data[d].cnt = 0;
                        }
                        let responseData = response.data.data;
                        for (let res of responseData) {
                            for (let d in this.data) {
                                if (this.data.hasOwnProperty(d)) {
                                    if (this.data[d].extended_status.includes(res.extended_status)) {
                                        if (this.data[d].extended_status[0] === 5) {
                                            this.data[d].amount += parseInt(res.refund_amount);
                                            this.data[d].cnt += res.cnt
                                        } else {
                                            this.data[d].amount += parseInt(res.amount) - parseInt(res.refund_amount);
                                            this.data[d].cnt += res.cnt
                                        }
                                    }
                                }
                            }
                        }
                    })
                    .then(() => {
                        this.$store.commit('unsetLoading');
                    });
            },
            formatPrice(value) {
                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
            }
        },
    }
</script>

<style scoped>

</style>
